import {
  Button,
  TextField,
  Box,
  Grid,
  Paper,
  useMediaQuery,
} from '@mui/material';
import { Form, Formik } from 'formik';
import PermissionDialog from './PermissionDialog';
import React, { useMemo } from 'react';
import { filterOnlyPlatformPermissions } from '../../../utils/adminMode';

export const translateRoleName = (name: string) => {
  switch (name) {
    default:
      return name;
  }
};

const RoleForm = (props: any) => {
  const { entity, onSubmit, errors, handleCancel, permissions } = props;

  const [openPermissionDialog, setOpenPermissionDialog] = React.useState(false);
  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down('sm')
  );

  const platformPermissionIdSet = useMemo(() => {
    const list = Array.isArray(permissions) ? permissions : [];
    return new Set(
      filterOnlyPlatformPermissions(list)
        .map((p: any) => p.id)
        .filter((id: any) => id !== null && id !== undefined)
    );
  }, [permissions]);

  const countPlatformSelected = (selected: unknown) => {
    if (!Array.isArray(selected)) return 0;
    return selected.filter((id) => platformPermissionIdSet.has(id)).length;
  };

  return (
    <Formik
      initialValues={entity}
      enableReinitialize={true}
      validate={(values) => {
        const errors: any = {};
        if (!values.name) {
          errors.name = 'Kötelező mező!';
        }

        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        // Persist only SaaS platform permissions on Identity roles.
        const platformOnly = Array.isArray(values.permissions)
          ? values.permissions.filter((id: any) =>
              platformPermissionIdSet.has(id)
            )
          : [];
        onSubmit({ ...values, permissions: platformOnly }, setSubmitting);
      }}
    >
      {({
        isSubmitting,
        values,
        touched,
        handleChange,
        setFieldValue,
        errors: validationErrors,
      }) => (
        <Form>
          {' '}
          <Paper>
            <Grid
              container
              spacing={2}
              sx={{
                justifyContent: 'left',
                p: 5,
              }}
            >
              <h2>
                Szerepkör {values.id > 0 ? 'szerkesztése' : 'létrehozása'}
              </h2>
              <Grid
                size={12}
                sx={{
                  pt: 5,
                }}
              >
                <Box
                  sx={{
                    color: 'red',
                  }}
                >
                  {errors.map((error: string) => (
                    <li>{error}</li>
                  ))}
                </Box>
              </Grid>
              <Grid size={12}>
                <TextField
                  value={translateRoleName(values.name)}
                  onChange={handleChange}
                  label="Megnevezés"
                  name="name"
                  fullWidth
                  disabled={values.isSystem}
                  autoFocus
                  error={!!touched.name && !!validationErrors.name}
                  helperText={
                    !!touched.name &&
                    !!validationErrors.name &&
                    (validationErrors.name as string)
                  }
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  value={values.description}
                  onChange={handleChange}
                  label="Megjegyzés"
                  name="description"
                  fullWidth
                  autoFocus
                  error={
                    !!touched.description && !!validationErrors.description
                  }
                  helperText={
                    !!touched.description &&
                    !!validationErrors.description &&
                    (validationErrors.description as string)
                  }
                />
              </Grid>
              <Grid size={12}>
                <Button
                  variant="outlined"
                  onClick={() => setOpenPermissionDialog(true)}
                >
                  Jogosultságok módosítása
                  {` (${countPlatformSelected(values.permissions)})`}
                </Button>
                <PermissionDialog
                  open={openPermissionDialog}
                  permissions={permissions}
                  selectedPermissions={
                    Array.isArray(values.permissions)
                      ? values.permissions.filter((id: any) =>
                          platformPermissionIdSet.has(id)
                        )
                      : []
                  }
                  selectionMode="id"
                  onlyPlatformPermissions
                  excludePlatformPermissions={false}
                  title="SaaS platform jogosultságok"
                  onClose={(selectedPermissions: any) => {
                    setFieldValue('permissions', selectedPermissions);
                    setOpenPermissionDialog(false);
                  }}
                />
              </Grid>
              <Grid
                container
                sx={{
                  pt: 3,
                  justifyContent: 'left',
                }}
              >
                <Grid
                  size={{ xs: 12, sm: isSmallScreen ? 12 : 'auto' }}
                  sx={{
                    p: 1,
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth={isSmallScreen}
                    disabled={isSubmitting}
                  >
                    Mentés
                  </Button>
                </Grid>

                <Grid
                  size={{ xs: 12, sm: isSmallScreen ? 12 : 'auto' }}
                  sx={{
                    p: 1,
                  }}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth={isSmallScreen}
                    onClick={handleCancel}
                  >
                    Mégse
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
      )}
    </Formik>
  );
};

export default RoleForm;
